import "../../IpynbRenderer.css";
import { jsx } from "react/jsx-runtime";
import React__default, { useState, useEffect } from "react";
import { ErrorType } from "../utils/error.js";
import NotebookJS from "notebook";
const parseNotebook = (file, onError) => {
  try {
    const json = JSON.parse(file);
    const notebookJS = NotebookJS.parse(json);
    return notebookJS.render().outerHTML;
  } catch (e) {
    onError("Unable to parse as Notebook!");
    return "";
  }
};
const JupyterRenderer = React__default.memo(({ file, onError }) => {
  const [__html, setHTML] = useState();
  useEffect(() => {
    try {
      const html = parseNotebook(file, onError);
      setHTML(html);
    } catch (error) {
      onError(error, {
        publicMessage: "Failed to load selected notebook.",
        publicSubject: "Unable to parse the selected notebook.",
        silent: true,
        type: ErrorType.Input
      });
    }
  }, [file, onError]);
  return __html ? /* @__PURE__ */ jsx("div", { className: "ipynb-renderer-root", dangerouslySetInnerHTML: { __html } }) : /* @__PURE__ */ jsx("div", { children: file });
});
export {
  JupyterRenderer as default,
  parseNotebook
};
